/* 498 Vintage: 1-of-1 badges — DOM injector
 *
 * Finds the product description block and inserts the badges HTML
 * immediately after it. The badges are created entirely in JS so we
 * don't depend on the server-rendered position, which can be wrong on
 * mobile (the section renders the badges as a sibling of the group-block,
 * not inside it, and the group-block can wrap to two columns on small
 * viewports).
 *
 * Selector strategy: the description is a .text-block with the .rte
 * class (rich text). The title is .text-block with .h2 (no .rte), and
 * the badges (when server-rendered) don't have .text-block at all.
 * So .text-block.rte uniquely targets the description.
 *
 * Runs on DOMContentLoaded. Idempotent — re-running does nothing if
 * the badges are already in place.
 */
(function () {
  'use strict';

  var BADGES_HTML =
    '<div class="vintage-1of1-badges" data-498vintage="1of1-badges">' +
      '<div class="vintage-1of1-badges__row">' +
        '<span class="vintage-1of1-badges__dot vintage-1of1-badges__dot--green" aria-hidden="true"></span>' +
        '<span class="vintage-1of1-badges__text">Versand in 2-4 Tagen</span>' +
      '</div>' +
      '<div class="vintage-1of1-badges__row">' +
        '<span class="vintage-1of1-badges__dot vintage-1of1-badges__dot--red" aria-hidden="true"></span>' +
        '<span class="vintage-1of1-badges__text"><strong>1 von 1</strong> &mdash; wenn weg, dann weg</span>' +
      '</div>' +
    '</div>';

  function injectBadges() {
    // Already in place? Bail.
    if (document.querySelector('.vintage-1of1-badges')) return;

    // Find the description block. The product description is the only
    // .text-block with the .rte class in the product-details column.
    var desc = document.querySelector('.product-details .text-block.rte');
    if (!desc) return;

    // Insert the badges immediately after the description.
    desc.insertAdjacentHTML('afterend', BADGES_HTML);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadges, { once: true });
  } else {
    injectBadges();
  }
})();
